//@author: devin
import { ChangeDetectionStrategy, Component, NgZone, OnInit, ViewEncapsulation } from "@angular/core";
import { TaxesService } from "../../../services/taxes.service";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-tax-schedules-dropdown")
@Component({
    selector: "s25-ng-tax-schedules-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [items]="items"
                [value]="value()"
                [onSelect]="onSelect"
                [searchEnabled]="true"
                [hasFav]="false"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [focusFirst]="focusFirst"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [apiBean]="apiBean"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                (valueChange)="onValueChange($event)"
            />
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25TaxSchedulesDropdownComponent extends S25DropdownAbstract implements OnInit {
    constructor(private zone: NgZone) {
        super();
    }

    ngOnInit() {
        TaxesService.getTaxes().then((data: any) => {
            this.zone.run(() => {
                this.items = data.map((obj: any) => {
                    return { itemName: obj.tax_name, itemId: obj.tax_id };
                });
                this.onLoad && this.onLoad();
                this.cd.detectChanges();
            });
        });
    }
}
